var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "26.616%",
    x2: "0%",
    y2: "74.985%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071955",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377DAA",
    offset: "28.579%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44985D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 81,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 11)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    width: 58,
    height: 41,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.064 14.768c0-.664-.128-1.312-.384-1.944a4.635 4.635 0 0 0-1.104-1.6c-.536-.512-1.12-.872-1.76-1.08-.64-.2-1.512-.304-2.608-.304H31.424v9.856H46.2c1.096 0 1.968-.104 2.608-.304.64-.2 1.224-.56 1.76-1.072.488-.464.856-1 1.104-1.6a5.122 5.122 0 0 0 .392-1.952M52.064 25.944c0-.664-.128-1.312-.384-1.952a4.665 4.665 0 0 0-1.104-1.608c-.536-.512-1.12-.872-1.76-1.08-.64-.208-1.512-.304-2.608-.304H31.424v9.872H46.2c1.096 0 1.968-.104 2.608-.304a4.494 4.494 0 0 0 1.76-1.08c.488-.464.856-1 1.104-1.608a4.927 4.927 0 0 0 .392-1.936M30.096 19.696C29.8 13.32 25.216 9.208 18.008 9.208c-7.44 0-12.104 4.4-12.104 11.152 0 6.968 4.848 11.152 12.104 11.152 7.264 0 11.8-4.136 12.088-10.512H18.392v-1.312h11.704v.008z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLogo);
export default __webpack_public_path__ + "static/media/credit-card-logo.8d3e68e36181a5b5e4305e279a481447.svg";
export { ForwardRef as ReactComponent };